import { setAllModulePermissions } from '../redux/reducers/permissionsReducer';
import { createMongoAbility } from '@casl/ability';
import createAbilitiesFromBinaryString from '@/shared/components/permissionHandler';
import { breadcrumbs } from '../containers/App/Router/mainPageExports';
import localforage from 'localforage';
import { LogoutAction } from '@/redux/actions/authActions';
import { authCookies } from './cookies';

// Updates the decoded permissions object based on provided mappings
export const updateDecodedPermissions = (decoded, mappings) => {
  if (!decoded.permissions) {
    return decoded;
  }
  // Ensure permissions object is extensible
  if (!Object.isExtensible(decoded.permissions)) {
    decoded.permissions = { ...decoded.permissions };
  }
  // Map binary permissions to specific items
  Object.keys(decoded.permissions).forEach((moduleKey) => {
    if (mappings[moduleKey]) {
      const binaryCode = decoded.permissions[moduleKey];

      mappings[moduleKey].forEach((item) => {
        decoded.permissions[item] = binaryCode;
      });
    }
  });

  return decoded;
};

// Generates module permissions and dispatches them to the store

export const generateModulePermissions = (decodedPermissions, permissionsNames, module, dispatch) => {
  // console.log('decodedPermissions', decodedPermissions)
  if (Object.prototype.hasOwnProperty.call(decodedPermissions, module)) {
    // Create abilities using CASL
    const abilities = new createMongoAbility(
      createAbilitiesFromBinaryString(decodedPermissions[module], module, permissionsNames),
    );
    // Reduce permissions to a key-value object
    const permissions = permissionsNames?.reduce((acc, permission) => {
      acc[permission] = abilities.can(permission, module);
      return acc;
    }, {});
    // Dispatch the permissions to the store
    dispatch(setAllModulePermissions({ key: module, value: permissions }));
  }
};

// Extracts unique first word breadcrumbs from the breadcrumbs object

export const uniqueFirstWordBreadcrumbs = Array.from(
  new Map(
    Object.entries(breadcrumbs)
      .flatMap(([path, label]) => {
        const parts = path.split('/').filter(Boolean);
        const firstWord = parts[0];
        const secondWord = parts[1];
        if (!firstWord) return [];
        if (firstWord === 'documents' && secondWord) {
          return [
            // [firstWord, { value: `/${firstWord}/`, label: firstWord }],
            [secondWord, { value: `/${firstWord}/${secondWord}/`, label: secondWord }],
          ];
        }

        return [[firstWord, { value: `/${firstWord}/`, label: firstWord }]];
      })
      .filter((entry) => entry !== undefined),
  ).values(),
);

let previousModulePermissionsLength = 0;

// Filters allowed routes based on module permissions
export const filterAllowedRoutes = (
  routes,
  modulePermissions,
  dispatch,
  setAllAllowedRoutes,
  setAllowedModulePermissions,
) => {
  // Create a Set of allowed modules for O(1) lookup
  const allowedModules = new Set(
    Object.entries(modulePermissions)
      .filter(([_, value]) => value === '1')
      .map(([key]) => key.toLowerCase()),
  );

  // Memoize the path extraction
  const getFirstPathSegment = (path) => path.split('/')[1]?.toLowerCase();

  // Single pass through routes
  const allowedRoutes = routes.filter((route) => allowedModules.has(getFirstPathSegment(route.path)));

  // Only update state if there are changes
  setAllAllowedRoutes(allowedRoutes);

  // Map in single pass without creating intermediate array
  dispatch(setAllowedModulePermissions(allowedRoutes.map((route) => ({ path: route.path }))));
};

export const authRedirect = (token, isLoggedIn, location, navigate, username, dispatch) => {
  authCookies(isLoggedIn, navigate, dispatch);
  if (token && isLoggedIn && location.pathname === '/') {
    navigate('/tickets/');
  } else if ((!isLoggedIn || isLoggedIn === undefined) && location.pathname === '/') {
    navigate('/login');
    localforage.dropInstance({ name: 'STN', storeName: 'stnOne' });
    dispatch(LogoutAction(username, navigate));
    localStorage.removeItem('currentCustomerID');
    window.indexedDB.deleteDatabase('STN');
    localStorage.clear();
    sessionStorage.clear();
  }
};
